(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matsuCampaignCountdownStickyLoaded) return;
    window.matsuCampaignCountdownStickyLoaded = true;

    const selector = '[data-campaign-countdown-bar]';

    const updateCampaignBarHeight = () => {
      const bar = Array.from(document.querySelectorAll(selector)).find((element) => {
        return element.isConnected && element.offsetParent !== null;
      });
      const height = bar ? Math.ceil(bar.getBoundingClientRect().height) : 0;

      document.documentElement.style.setProperty('--campaign-countdown-bar-height', `${height}px`);
    };

    const scheduleUpdate = () => requestAnimationFrame(updateCampaignBarHeight);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleUpdate);
    } else {
      scheduleUpdate();
    }

    window.addEventListener('resize', scheduleUpdate);
    document.addEventListener('theme:resize', scheduleUpdate);
    document.addEventListener('theme:resize:width', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('shopify:section:unload', scheduleUpdate);

    if (document.body) {
      new MutationObserver(scheduleUpdate).observe(document.body, {childList: true, subtree: true});
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
